import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authSlice from '@store/slices/auth.slice'
import audioSlice from '@store/slices/audio.slice'
import areaSlice from '@store/slices/area.slice'
import broadcastSlice from '@store/slices/broadcast.slice'
import jingleSlice from '@store/slices/jingle.slice'
import newsSlice from '@store/slices/news.slice'
import stationSlice from '@store/slices/station.slice'
import timeslotSlice from '@store/slices/timeslot.slice'
import voiceSlice from '@store/slices/voice.slice'
import audioMessageSlice from '@store/slices/audioMessage.slice'
import noteSlice from '@store/slices/note.slice'
import sectionSlice from '@store/slices/section.slice'
import authorSlice from '@store/slices/author.slice'
import regionalPostSlice from '@store/slices/regionalPost.slice'
import * as Sentry from "@sentry/react"

const rootReducer = combineReducers({
  area: areaSlice,
  audio: audioSlice,
  auth: authSlice,
  broadcast: broadcastSlice,
  jingle: jingleSlice,
  news: newsSlice,
  station: stationSlice,
  timeslot: timeslotSlice,
  voice: voiceSlice,
  audioMessage: audioMessageSlice,
  note: noteSlice,
  section: sectionSlice,
  author: authorSlice,
  posts: regionalPostSlice,
})

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

export const store = configureStore({
  reducer: rootReducer,
  enhancers: (getDefaultEnhancers) => {
      return getDefaultEnhancers().concat(sentryReduxEnhancer)
    },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['audio/downloadAudio/fulfilled', 'persist/PERSIST'], // Ignore this action type
      },
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
